export default "__VITE_ASSET__ek$F6Isg__$_?url__"